import { FaFacebook, FaWhatsapp,FaTwitter,FaLinkedin,FaYoutube, FaPhone, FaInstagram, FaGithub } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import { Link } from "react-router-dom";
const Footer = () => {
    return (
        <div className="flex flex-col w-full justify-center items-center bg-gray-500">
            <div className="w-full  py-8 px-2 grid grid-cols-1 md:grid-cols-3  gap-y-8 ">
                <div className="w-full flex flex-col items-center space-y-4 text-white ">
                    <div className=" font-extrabold text-2xl font-mono">Address</div>
                    <div className="">plot 8 Ogbaga Road <br />
                        Abakaliki, Ebonyi State <br />
                        Nigeria.
                    </div>
                </div> 
                <div className="w-full flex flex-col items-center space-y-4 text-white ">
                    <div className=" font-extrabold text-2xl font-mono">Quick Links</div>
                    <div className="flex flex-col space-y-2">
                        <Link reloadDocument to="/">Home</Link>
                        <Link reloadDocument to="/about">About me</Link>
                        <Link reloadDocument to="/skills">Skills</Link>
                        <Link reloadDocument to="/services">Services</Link>
                        <Link reloadDocument to="/projects">Projects</Link>
                        <Link reloadDocument to="/contact">Contact me</Link>
                        <Link reloadDocument to="/hireMe">Hire me</Link>
                        
                    </div>
                </div>
                <div className="w-full flex flex-col items-center space-y-4 text-white ">
                    <div className=" font-extrabold text-2xl font-mono">Reach Me</div>
                    <div className="grid grid-cols-4 gap-y-4 gap-x-4">
                        <a href="tel:+2348165459380"><FaPhone size={30}/></a>
                        <a href="https://wa.me/+2348165459380"><FaWhatsapp size={30}/></a>
                        <a href="https://www.facebook.com/profile.php?id=100068156498882"><FaFacebook size={30}/></a>
                        <a href="https://linkedin.com/in/udoka-otsu-526a02265"><FaLinkedin size={30}/></a>
                        <a href="www.instagram.com/otsu_udoka"><FaInstagram size={30}/></a>
                        <a href="www.twitter.com/otsu_udoka"><FaTwitter size={30}/></a>
                        <a href="https://github.com/udoka4397"><FaGithub size={30}/></a>
                        <a href="www.youtube.com/udokaotsu1122"><FaYoutube size={30}/></a>
                        <a href="mailto:otsuudoka@gmail.com"><AiOutlineMail size={30}/></a>
                    </div>
                </div>
                
            </div>
            <small className="text-white">All right reserved &copy;<span>udo<span className="text-yellow-500">ka</span></span> 2023</small>
            <small className="text-white">Built by <Link reloadDocument className="underline" to="/">otsu udoka</Link></small>
        </div>
    );
}

export default Footer;